var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-3 py-2"},[_c('fdw-prop-finder',{attrs:{"client":"114","league":"nba","show-headshots":"true","show-previous-results":"true","team-id":"2:28"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }